// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-k_gA","advertDetailContacts__header":"c-k_gB"};